import React, { useCallback, useEffect, useRef } from "react";
import { Icon } from "@jsq/ds/icons";
import {
  filterPopoverPanel,
  filterPopoverWrapper,
  filterTriggerButton,
  filterTriggerButtonActive,
} from "./styles_vanilla.css";

type Props = {
  label: string;
  isActive: boolean;
  isOpen: boolean;
  onToggle: () => void;
  onClose: () => void;
  children: React.ReactNode;
};

export const FilterPopover: React.FC<Props> = ({
  label,
  isActive,
  isOpen,
  onToggle,
  onClose,
  children,
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
      onCloseRef.current();
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, handleClickOutside]);

  const buttonClass = isActive
    ? `${filterTriggerButton} ${filterTriggerButtonActive}`
    : filterTriggerButton;

  return (
    <div ref={wrapperRef} className={filterPopoverWrapper}>
      <button type="button" onClick={onToggle} className={buttonClass}>
        {label}
        <Icon type={isOpen ? "chevron-up" : "chevron-down"} size="small" />
      </button>
      {isOpen && <div className={filterPopoverPanel}>{children}</div>}
    </div>
  );
};
